export default "__VITE_ASSET__DXfpkNX2__"